export default __webpack_public_path__ + "images/04790cbd873034298c4570a2153d3f19.png";